/*
 * This file is part of glowingblue/newvigation.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { override } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import TagsPage from 'flarum/tags/forum/components/TagsPage';
import IndexPageHero from './components/IndexPageHero';

// Make translation calls shorter
const t = app.translator.trans.bind(app.translator);

export default function () {
	if (app.initializers.has('flarum-tags')) {
		override(TagsPage.prototype, 'hero', function () {
			const title = t('flarum-tags.forum.index.tags_link');
			const icon = 'fas fa-th-large';

			return <IndexPageHero title={title} icon={icon} />;
		});
	}
}
